import * as z from "zod/v4";

export const getMarketingSubscriberCounts = {
  name: "getMarketingSubscriberCounts" as const,
  input: z.null(),
  output: z.object({
    smsSubscriberCount: z.number(),
    emailSubscriberCount: z.number(),
    emailEligibleCount: z.number(),
    totalSubscriberCount: z.number(),
    emailSubscribesOverTime: z.array(
      z.object({ date: z.date(), value: z.number() }),
    ),
    smsSubscribesOverTime: z.array(
      z.object({ date: z.date(), value: z.number() }),
    ),
  }),
};
